// src/features/messages/meta.ts — static tables + helpers for the messenger.
import type { MessageMedia } from '@/core/models/message';

/** The conversation-list filter. */
export type ConvoFilter = 'all' | 'unread' | 'requests' | 'group';

export interface FilterDef { id: ConvoFilter; label: string; }

// 1.24.00: 'requests' holds DMs from people the member doesn't follow. They are
// deliberately kept OUT of All/Unread — that separation is the whole feature.
export const FILTERS: FilterDef[] = [
  { id: 'all',      label: 'All' },
  { id: 'unread',   label: 'Unread' },
  { id: 'requests', label: 'Requests' },
  { id: 'group',    label: 'Groups' },
];

/** Human label for a media message (used in row previews + bubbles). */
export function mediaLabel(media: MessageMedia): string {
  return media === 'image' ? 'Photo' : 'Voice message';
}

// De-rainbowed media surface for image-media tiles/bubbles (messages carry no tone).
// Solid void-ramp + faint teal — NEVER blue/violet/purple. Differentiation comes
// from the glyph/label, not colour. Hardcoded hex is the accepted styled-components
// exception (mirrors explore/communities VOID_TEAL_SURFACE).
// A flat surface. Was a 135deg ramp ending in a 10% purple wash, over two
// hexes from the retired slate ramp — a gradient nobody could see doing work,
// stranded on colours the theme no longer ships.
export const MEDIA_SURFACE = '#1C1C1F';

// Back-compat alias: every image-media tile now maps to the single void-teal surface.
export const MEDIA_GRADIENTS: string[] = [MEDIA_SURFACE];
